/**
 * Background block animations
 */
document.querySelectorAll('.bg--type-x > .x-symbol').forEach(x => {
  morph_on_scroll(x);
});